import React, { useState, useEffect } from 'react';
import {
    HStack,
    IconButton,
    Image,
    Text,
    Badge,
    Box,
    Heading,
    Button,
    SimpleGrid,
    Grid,
    GridItem, VStack, ModalHeader, ModalCloseButton, ModalBody, Flex
} from "@chakra-ui/react";
import {keyframes} from "@emotion/react";
import {useRef} from "react";
import {useInViewport} from "react-in-viewport";
import PictureContainer from "../components/PictureContainer";
import img9 from "../gallery/hinge_door_1.jpg"
import img22 from "../gallery/staircase_5.jpg"
import img21 from "../gallery/securitydoor_14.jpg"

import img16 from "../gallery/alu_hinge_1.jpg"
import img10 from "../gallery/pivotdoor_15.jpg"
import img34 from "../gallery/cover_1.jpg"
import ImageCard from "../components/ImageCard";

import "./Gallery.css"
import {ArrowLeftIcon, ArrowRightIcon} from "@chakra-ui/icons";

function Gallery (){

    const [currentIndex, setCurrentIndex] = useState(null);
    const images = [img9,img22,img21,img16,img10,img34]

    // 顶部其他 useState 后面
    const thumbRefs = useRef([]);            // 保存所有缩略图 DOM
    thumbRefs.current = [];                  // 先清空，防止热更新重复


    const handlePrev = () => {
        if (currentIndex == null){
            setCurrentIndex(0)
        }else{
            setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
        }
    };

    const handleNext = () => {
        if (currentIndex == null){
            setCurrentIndex(0)
        }else{
            setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
        }


    };

    const handleSelect = (index) => {
        setCurrentIndex(index);
    };
    // console.log(currentIndex)
    const title_style_1 = { base: "18px", sm:"44px", md: "4vh", lg: "31px", "2xl":"35px"};

    useEffect(() => {
        // 只要 currentIndex 更新，就把对应缩略图滚到可视区域
        const node = thumbRefs.current[currentIndex];
        if (node) {
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',   // 纵向布局时有效
                inline: 'center'    // 横向布局时居中
            });
        }
    }, [currentIndex]);       // 记得把 currentIndex 放依赖里


    return(
        <>
            <VStack w = {{base: "100vw" , md:"80vw"}} minH = "fit-content" display = "flex" justifyContent = "center" alignItems = "center" paddingTop = "100px" paddingBottom = "100px">
                <Box w="100%" borderRadius="0" >
                    <Heading fontSize={title_style_1} paddingBottom = {{base:"15px",md:"70px"}} align = "center" borderTopRadius = "0px" bg = "white" color = "black">Gallery</Heading>

                    <Box display="flex" flexDirection={{base:"column",md:"row"}}  justifyContent={"center"} alignItems = "center">
                        <Box  width = {{base:"95vw",md:"55vw"}} h = {{base:"50vh",md:"64vh"}}  position="relative" display="flex" alignItems="center" justifyContent="center">
                            {
                                currentIndex!==null?
                                <Image
                                    src={images[currentIndex]}
                                    maxHeight= {{base:"50vh",md:"64vh"}}
                                    w={{base:"69vw",md:"40vw"}}
                                    objectFit="contain"
                                    borderRadius="md"
                                    boxShadow="xl"
                                />:
                                    <p>Select an image from the list to view.</p>
                            }

                            {/* 左右切换按钮 */}
                            <IconButton
                                icon={<ArrowLeftIcon />}
                                position="absolute"
                                left="10px"
                                top="50%"
                                transform="translateY(-50%)"
                                onClick={handlePrev}
                                aria-label="Previous"
                                zIndex="1"
                            />
                            <IconButton
                                icon={<ArrowRightIcon />}
                                position="absolute"
                                right="10px"
                                top="50%"
                                transform="translateY(-50%)"
                                onClick={handleNext}
                                aria-label="Next"
                                zIndex="1"
                            />
                        </Box>

                        {/* 下方缩略图展示区域*/}
                        <Box borderRadius="md" mt = {{base: "2%", md: 0}} padding = "25px" width = {{base:"80%",md:"20%"}} h = {{base:"21vh",md:"64vh"}}  overflow="auto"
                             shadow = "inset 0px -10px 25px -15px grey;">
                            <Flex flexDir={{base:"row",md:"column"}} gap={3} overflow="auto" align = "center">
                                {images.map((img, index) => (
                                    <Image
                                        key={index}
                                        src={img}
                                        height={{base:"35%", md:"70%"}}
                                        width={{base:"35%", md:"70%"}}
                                        objectFit="cover"
                                        borderRadius="md"
                                        cursor="pointer"
                                        border={currentIndex === index ? '2px solid #AD3F45' : '2px solid transparent'}
                                        onClick={() => handleSelect(index)}
                                        _hover={{ border: '2px solid #AD3F45' }}
                                        ref={el => (thumbRefs.current[index] = el)}
                                    />
                                ))}
                            </Flex>
                        </Box>
                    </Box>
                </Box>
                {/*<Box mt="2vh" align = "center" ref={myref}>*/}
                {/*    {enterCount > 0?*/}
                {/*    <>*/}
                {/*        <Heading paddingBottom = "70px" fontSize={title_style_1}>*/}
                {/*        Our work gallery</Heading>*/}

                {/*        /!*w:h = 11:8*!/*/}
                {/*    <Grid*/}
                {/*        h ={height}*/}
                {/*        w ={width}*/}
                {/*        templateRows='repeat(8, 1fr)'*/}
                {/*        templateColumns='repeat(11, 1fr)'*/}
                {/*        gap={"5px"}*/}
                {/*        mb={"2vh"}*/}
                {/*        mt="2vh"*/}
                {/*    >*/}
                {/*        <GridItem className = "grid_item" animation={enterCount === 1 ? appear_ani_2 : ""} rowSpan={4} colSpan={3} bg='tomato'*/}
                {/*        >*/}
                {/*           <ImageCard image={img9}></ImageCard>*/}
                {/*        </GridItem>*/}
                {/*        <GridItem className = "grid_item" animation = {enterCount===1?appear_ani_6:""} rowSpan={5} colSpan={4} bg='green'>*/}
                {/*            <ImageCard image= {img22}></ImageCard>*/}
                {/*        </GridItem>*/}
                {/*        <GridItem className = "grid_item" animation = {enterCount===1?appear_ani_3:""} rowSpan={3} colSpan={4} bg='papayawhip'>*/}
                {/*            <ImageCard image= {img21} ></ImageCard>*/}
                {/*        </GridItem>*/}
                {/*        <GridItem className = "grid_item" animation = {enterCount===1?appear_ani_4:""} rowSpan={5} colSpan={4} bg='green'>*/}
                {/*            <ImageCard image= {img10} ></ImageCard>*/}
                {/*        </GridItem>*/}

                {/*        <GridItem className = "grid_item" animation = {enterCount===1?appear_ani_2:""} rowSpan={4} colSpan={3} bg='tomato' >*/}
                {/*            <ImageCard image= {img16}  ></ImageCard>*/}
                {/*        </GridItem>*/}
                {/*        <GridItem className = "grid_item" animation = {enterCount===1?appear_ani_5:""} rowSpan={3} colSpan={4} bg='papayawhip' >*/}
                {/*            <ImageCard image = {img34} ></ImageCard>*/}
                {/*        </GridItem>*/}
                {/*    </Grid>*/}
                {/*    </>*/}
                {/*        :*/}
                {/*        ""*/}
                {/*    }*/}
                {/*</Box>*/}
            </VStack>
        </>

    )
}

export default Gallery;